module.exports = __webpack_public_path__ + "img/algolia-blue-mark.8b893f6.svg";